import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { SidebarService } from '../../core/services/sidebar.service';
import { ModalService } from '../../core/services/modal.service';
import { ModalType } from '../../core/enums/modal-type.enum';

@Component({
  selector: 'app-quick-actions-buttons',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './quick-actions-buttons.component.html',
  styleUrls: ['./quick-actions-buttons.component.scss'],
})
export class AccionesRapidasButtonsComponent {
  private modalService = inject(ModalService);
  private sidebarService = inject(SidebarService);

  agregarUsuario() {
    this.modalService.open(ModalType.USER);
    this.sidebarService.closeSidebar();
  }

  agregarEquipo() {
    this.modalService.open(ModalType.TEAM);
    this.sidebarService.closeSidebar();
  }

  agregarApp() {
    this.modalService.open(ModalType.APP);
    this.sidebarService.closeSidebar();
  }
}
